export enum AdminSubscriptionTopic {
  EmployeeTaggedInMatchComment = 'employeeTaggedInMatchComment',
  UnreadEmailDelta = 'unreadEmailDelta',
  PflegiaForFriendsRefereeActivity = 'pflegiaForFriendsRefereeActivity',
  EmailGenerationWithAi = 'emailGenerationWithAi',
  WhatsAppInbound = 'whatsAppInbound',
}
